<template>
  <div>
    <button class="btn btn-sm btn-primary mb-2 d-none" id="delete-payroll-btn" data-toggle="modal" data-target="#delete-payroll-modal">
        <i class="fa fa-cogs"></i>
        Process Payroll
    </button>
    <!-- Modal -->
    <div class="modal fade" id="delete-payroll-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Are you sure you want to delete this payroll?</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-sm btn-default" data-dismiss="modal" aria-label="Close">
                Cancel
              </button>
              <button type="button" class="btn btn-sm btn-danger" @click="deletePayrollAction()">
                Delete
              </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  methods: {
    ...mapActions('payroll', [
      'deletePayroll'
    ]),

    deletePayrollAction(){
      this.deletePayroll();
      location.reload();
    }
  }
}
</script>
